import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  TableContainer,
  Paper,
  Table,
  TableRow,
  TableHead,
  TableCell,
  TableBody,
  Button,
  Grid,
  TextField,
  Tooltip,
  IconButton,
  Avatar,
} from "@mui/material";
import { Container } from "@mui/system";
import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
import gif from "../../img/new-animated-icon.gif";
import "./Report.css";
import newIcn from "../../icons/new.svg";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import eyeIcon from "../../icons/eye.svg";
import moment from "moment";
import Excel from "../../img/excel.png";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { useState } from "react";
import EmpWisTable from "./EmpWiseReportExcel";
import InfoIcon from "@mui/icons-material/Info";
import ImageView from "./ImageView";
import { Base64 } from "js-base64";
import { CustomUserModal } from "./SummaryReport";
import XLSX from "sheetjs-style";
import { useCallback } from "react";

const IndividualReport = (props) => {
  console.log("individual report is rendering.....");
  // alert("inn");
  const {
    data,
    fromDate,
    toDate,
    configurationName,
    communicationDetailsHeader,
    communicationDetailsDynamiceHeader,
    NewClientTitle,
    UniqueClients,
    fetchGetEmpWiseReportExportExcel = () => {},
    exportIndividualReport,
  } = props;
  console.log(
    configurationName,
    communicationDetailsHeader,
    communicationDetailsDynamiceHeader,
  );
  const [tableId, setTableId] = useState();
  const tableRef = useRef(null);
  const [ImgUrl, setImgUrl] = useState();
  const [OpenViewImageModal, setOpenViewImageModal] = useState(false);
  const [totalDistance, setTotalDistance] = useState(0);
  const [defaultMeetingModal, setDefaultMeetingModal] = useState({
    data: null,
    open: false,
  });
  const localData = JSON.parse(localStorage.getItem("data")) || {};

  const navigate = useNavigate();
  var base64regex =
    /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;

  const handleView = (id, date, odId) => {
    let newdate = new Date(date);
    const obj = {
      // hrmsUserId: JSON.parse(localStorage.getItem("data")).hrmsUserId,
      userId: id,
      filterUserId: id,
      fromDate: moment(newdate).format("YYYY-MM-DD"),
      toDate: moment(newdate).format("YYYY-MM-DD"),
      id: odId,
      // fromDate: fromDate,
      // toDate: toDate,
    };
    localStorage.setItem("singleDetail", JSON.stringify(obj));
    // navigate("/details");
    window.open(`/details/${id}`, "_blank");
  };

  function exportToExcel(type, fn, dl) {
    const worksheet = XLSX.utils.table_to_sheet(
      document.getElementById("empwiseId"),
    );

    const colName = (n) => {
      let s = "";
      while (n >= 0) {
        s = String.fromCharCode((n % 26) + 65) + s;
        n = Math.floor(n / 26) - 1;
      }
      return s;
    };

    const communicationHeaderLength =
      communicationDetailsDynamiceHeader?.length || 0;

    const range = XLSX.utils.decode_range(worksheet["!ref"]);
    for (let row = range.s.r; row <= range.e.r; row++) {
      for (let col = range.s.c; col <= range.e.c; col++) {
        const cellAddress = colName(col) + (row + 1);
        const cell = worksheet[cellAddress];
        if (!cell) continue;

        // Base style for all cells
        cell.s = {
          font: {
            name: "Liberation Serif",
            sz: 10,
          },
          alignment: {
            horizontal: "center",
            vertical: "center",
          },
        };

        // Bold styling
        if (
          row === 0 ||
          row === 1 ||
          (row === 2 && col < communicationHeaderLength)
        ) {
          cell.s.font.bold = true;
        }
      }
    }

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    XLSX.writeFile(workbook, `EMP Wise Report.xlsx`, {
      compression: true,
    });
  }

  const fetchGetEmpWiseReportExportExcelOnClick = (selectedId) => {
    fetchGetEmpWiseReportExportExcel(selectedId);
  };

  const exportHandler1 = (item) => {
    setTableId(item);
    if (item && item) {
      // setTimeout(() => {
      // document.getElementById("imployeWiseTable1").click();
      exportToExcel();
      // }, 500);
    }

    //  }
  };
  const openmodalhalndlerSingleID = (data) => {
    localStorage.setItem(
      "ExpencesData",
      JSON.stringify({
        communicationIds: [data ? data.id : null],
        odDailyDistanceIds: null,
        from: data && data.createdDateTime,
        to: data && data.createdDateTime,
        Status: null,
      }),
    );
    //data.clientCommunicationDtoList[0].createdDateTime,

    window.open("/expenseList", "_blanck");
  };
  const openmodalhalndler = (type, data) => {
    // const dataFilter = [];
    // localStorage.setItem(
    //   "ExpencesData",
    //   JSON.stringify({
    //     id: data.length !== 0 ? data[0].communicationId : null,
    //     from: data.length !== 0 ? data[0].expenseDate : new Date(),
    //     to: data.length !== 0 ? data[0].expenseDate : new Date(),
    //   })
    // );
    //window.open("/expenseList", "_self");

    let arryaIds = [];
    const odids =
      [data.clientCommunicationDtoList] &&
      [data.clientCommunicationDtoList].map((val) => {
        val &&
          val.map((arryid) => {
            arryaIds.push(arryid.id);
          });
      });
    localStorage.setItem(
      "ExpencesData",
      JSON.stringify({
        communicationIds: arryaIds ? arryaIds : [],
        odDailyDistanceIds: data ? data.id : null,
        from: data.createdDate ? data.createdDate : null,
        to: data.createdDate ? data.createdDate : null,
        Status: type ? (type !== "Total" ? type : null) : null,
      }),
    );

    window.open("/expenseList", "_blanck");

    //setExpencesData(data);
    //setopenExpenseModal(true);
  };
  const OpenImageDirectTopage = (url) => {
    window.open(url);
  };
  const viewImageRidarect = (data) => {
    console.log(
      data,

      "viewImageRidarect",
    );
    let imgUrlList = data && data !== undefined && data.split(",");
    console.log(imgUrlList, "imgUrlList");
    setImgUrl(imgUrlList);
    setOpenViewImageModal(true);
  };

  const handleViewDefaultMeeting = useCallback((curelem) => {
    console.log(curelem);
    setDefaultMeetingModal({
      data: curelem,
      open: true,
    });
  }, []);

  const handleCloseDefaultMeetingModal = useCallback(() => {
    setDefaultMeetingModal({
      data: null,
      open: false,
    });
  }, []);

  let workingdays = 0;
  const colorArray = ["#FFFF", "#F9F9F9"];
  let currentColor = colorArray[0];
  let workingDaysCount = [];
  let slNo = 0;
  return (
    <div>
      {/* <ExpenceModal
        ExpencesData={ExpencesData}
        openExpenseModal={openExpenseModal}
        setopenExpenseModal={setopenExpenseModal}
        title="Emp Wise Reports"
      /> */}

      {data &&
        data.length > 0 &&
        data.map((item, index, arr) => {
          /* item is per day data */
          // {
          /* let count;

          if (index == 0) {
            count = 1;
          } else {
            count = 0;
          }
          if (index !== 0) {
            if (
              item.createdDate ===
              item.clientCommunicationDtoList[index - 1].createdDate
            ) {
            } else {
              if (currentColor === colorArray[0]) {
                currentColor = colorArray[1];
              } else if (currentColor === colorArray[1]) {
                currentColor = colorArray[0];
              }
            }
          } */
          // }
          let initialVisits = {
            totalVisit: 0,
          };
          let initialNewClient = {
            totalClientNewCommunication: 0,
          };
          let initialUniqueClient = {
            totalUniqueClient: 0,
          };
          let initialDistance = {
            totalDistance: 0,
          };

          workingDaysCount = item.map((ele, index, a1) => {
            if (
              ele.clientCommunicationDtoList != null &&
              ele.clientCommunicationDtoList.length > 0
            ) {
              // ele.clientCommunicationDtoList.reduce(
              //   (accumulator, currentValue) =>workingdays++,workingdays
              // )
              {
                /* return ++workingdays; */
              }
              workingDaysCount = item.length;
              return workingdays;
            } else {
              return (workingdays = 0);
            }
          });
          // [0,0]
          //[1]
          // [1]
          const totalDistanceEmpWise = item.reduce(
            (accumulator, currentValue) =>
              Number(accumulator ? accumulator : 0) +
              Number(
                currentValue.totalDistance ? currentValue.totalDistance : 0,
              ),
            0,
          );

          const totalMeetings = item.reduce(
            (accumulator, currentValue) =>
              Number(accumulator ? accumulator : 0) +
              Number(currentValue.totalVisit ? currentValue.totalVisit : 0),
            0,
          );
          const newClients = item.reduce(
            (accumulator, currentValue) =>
              Number(accumulator ? accumulator : 0) +
              Number(
                currentValue.totalClientNewCommunication
                  ? currentValue.totalClientNewCommunication
                  : 0,
              ),
            0,
          );
          const uniqueClients = item.reduce(
            (accumulator, currentValue) =>
              Number(accumulator ? accumulator : 0) +
              Number(
                currentValue.totalUniqueClient
                  ? currentValue.totalUniqueClient
                  : 0,
              ),
            0,
          );

          const TotalExpenseAmount = item.reduce(
            (accumulator, currentValue) =>
              Number(accumulator ? accumulator : 0) +
              Number(
                currentValue.totalApprovedExpenseAndFareAmount
                  ? currentValue.totalApprovedExpenseAndFareAmount
                  : 0,
              ),
            0,
          );
          const TotalDistance = item.reduce(
            (accumulator, currentValue) =>
              Number(accumulator ? accumulator : 0) +
              Number(
                currentValue.totalDistance ? currentValue.totalDistance : 0,
              ),
            0,
          );
          // setTotalDistance(0)

          // const TotalExpenseAmount =
          //   item &&
          //   item[0].userExpenseDtoList &&
          //   item[0].userExpenseDtoList.reduce(
          //     (accumulator, currentValue) =>
          //       Number(accumulator ? accumulator : 0) +
          //       Number(currentValue.amount ? currentValue.amount : 0),
          //     0
          //   );

          return (
            <React.Fragment key={index}>
              <Container
                style={{
                  borderRadius: "8px",
                  overflow: "hidden",
                }}
                maxWidth="true"
              >
                {
                  <Accordion className="main_accoardian" defaultExpanded={true}>
                    <AccordionSummary
                      className="accordianHeader"
                      expandIcon={
                        <AddCircleIcon
                          fontSize="large"
                          style={{ color: "white" }}
                        />
                      }
                      aria-controls="panel1a-content"
                      style={{
                        background: "rgb(10 166 141)",
                        borderRadius: "10px 10px 0px 0px",
                        overflow: "hidden",
                      }}
                    >
                      <Box
                        className="top_table_status"
                        style={{ background: "rgb(10 166 141)" }}
                      >
                        <Grid container>
                          <Grid item xs={5} pr={3}>
                            <Box
                              sx={{
                                display: "flex",
                                gap: "6px",
                              }}
                            >
                              <div
                                className="field_box field_toggle"
                                style={{ background: "#2a3478", color: "#fff" }}
                              >
                                <div style={{ color: "#fff" }}>
                                  {` ${item[0].userName} ${
                                    item[0].empCode
                                      ? `(${item[0].empCode})`
                                      : ""
                                  }`}
                                </div>
                              </div>
                              <div className="field_box calender">
                                <span>From</span>
                                <TextField
                                  disabled
                                  name="fromDate"
                                  type="date"
                                  size="small"
                                  variant="outlined"
                                  value={fromDate}
                                />
                              </div>
                              <div className="field_box calender">
                                <span>To</span>
                                <TextField
                                  disabled
                                  name="fromDate"
                                  type="date"
                                  size="small"
                                  variant="outlined"
                                  value={toDate}
                                />
                              </div>
                            </Box>
                          </Grid>
                          <Grid item xs={7}>
                            <Box
                              className="right_status_colors"
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                height: "100%",
                              }}
                            >
                              <div
                                className="field_toggle"
                                style={{
                                  backgroundColor: "#F4ECB5",
                                }}
                              >
                                <span>Total Meetings</span>
                                <span className="count_bx">
                                  {totalMeetings ? totalMeetings : "0"}
                                </span>
                              </div>
                              <div
                                className="field_toggle"
                                style={{
                                  backgroundColor: "#E1EDC4",
                                }}
                              >
                                {newClients > 0 && (
                                  <img
                                    src={newIcn}
                                    className="newTag"
                                    alt=""
                                  ></img>
                                )}
                                <span>
                                  {localData?.isClientNameChanged
                                    ? (
                                        (NewClientTitle !== ""
                                          ? NewClientTitle
                                          : "New Clients") + ""
                                      )?.replace(
                                        /client/gi,
                                        localData?.changedClientFieldName ||
                                          "Client",
                                      )
                                    : NewClientTitle !== ""
                                      ? NewClientTitle
                                      : "New Clients"}
                                </span>
                                <span className="count_bx">
                                  {newClients ? newClients : "0"}
                                </span>
                              </div>
                              <div
                                className="field_toggle"
                                style={{
                                  backgroundColor: "#ECD0EF",
                                }}
                              >
                                <span>
                                  {localData?.isClientNameChanged
                                    ? (
                                        (UniqueClients !== ""
                                          ? UniqueClients
                                          : "Unique Clients") + ""
                                      )?.replace(
                                        /client/gi,
                                        localData?.changedClientFieldName ||
                                          "Client",
                                      )
                                    : UniqueClients !== ""
                                      ? UniqueClients
                                      : "Unique Clients"}
                                </span>
                                <span className="count_bx">
                                  {uniqueClients ? uniqueClients : "0"}
                                </span>
                              </div>
                              <div
                                className="field_toggle"
                                style={{
                                  backgroundColor: "#DAE2EE",
                                }}
                              >
                                <span>Working Days</span>
                                <span className="count_bx">
                                  {/* {
                                    workingDaysCount[
                                    workingDaysCount.length - 1
                                    ]
                                  } */}
                                  {item.length}
                                </span>
                              </div>
                              <div
                                className="field_toggle"
                                style={{
                                  backgroundColor: "#DAE2EE",
                                }}
                              >
                                <span> Expense</span>
                                <span className="count_bx">
                                  {TotalExpenseAmount && TotalExpenseAmount
                                    ? TotalExpenseAmount
                                    : "0"}
                                </span>
                              </div>
                              <div
                                className="field_toggle"
                                style={{
                                  backgroundColor: "#DAE2EE",
                                }}
                              >
                                <span> Total Distance</span>
                                <span className="count_bx">
                                  {TotalDistance && TotalDistance
                                    ? TotalDistance.toFixed(2)
                                    : "0"}
                                </span>
                              </div>
                              <div>
                                <Tooltip
                                  title="Export Excel"
                                  sx={{ width: "20px" }}
                                  // onClick={() => exportHandler1(item)}
                                  // onClick={() =>
                                  //   fetchGetEmpWiseReportExportExcelOnClick(
                                  //     item[0]?.userId
                                  //   )
                                  // }
                                  onClick={() =>
                                    exportIndividualReport({
                                      userId: item[0]?.userId,
                                      fromDate:
                                        fromDate &&
                                        moment(fromDate).format("DD/MM/YYYY"),
                                      toDate:
                                        toDate &&
                                        moment(toDate).format("DD/MM/YYYY"),
                                    })
                                  }
                                >
                                  <img
                                    src={Excel}
                                    style={{
                                      width: "30px",
                                      marginTop: "2px",
                                      cursor: "pointer",
                                    }}
                                    alt=""
                                  />
                                </Tooltip>
                              </div>
                              {/* <div className="addIcn">
                                <AddCircleIcon />
                              </div> */}
                            </Box>
                          </Grid>
                        </Grid>
                      </Box>
                    </AccordionSummary>
                    <AccordionDetails className="accoardian_body">
                      <div style={{ display: "none" }}>
                        <ReactHTMLTableToExcel
                          id="imployeWiseTable1"
                          className="download-table-xls-button"
                          //  table={tableId}
                          table="empwiseId"
                          //currentTableRef={tableRef.current}
                          filename="EMP Wise Report"
                          sheet="tablexls"
                          buttonText="ImployeWiseTable as XLS"
                        />
                      </div>

                      <TableContainer
                        component={Paper}
                        style={{
                          height: "calc(-225px + 100vh)",
                          background: "#fff",
                        }}
                      >
                        <Table
                          size="small"
                          aria-label="a dense table"
                          sx={{
                            minWidth: 1200,

                            "& tbody td": {
                              border: "0.5px solid #d0d7de",
                            },

                            // First column
                            "& th:first-of-type, & td:first-of-type": {
                              position: "sticky",
                              left: 0,
                              zIndex: 2,
                              // backgroundColor: "#fff",
                            },

                            "td:first-of-type": {
                              backgroundColor: "#fff",
                            },

                            // Header cells
                            "& thead th": {
                              position: "sticky",
                              top: 0,
                              zIndex: 3,
                              backgroundColor: "rgb(32 80 130)",
                              border: "none",
                            },

                            // Top-left cell needs highest z-index
                            "& thead th:first-of-type": {
                              left: 0,
                              zIndex: 4,
                            },
                          }}
                        >
                          <TableHead>
                            <TableRow
                              sx={{
                                ".MuiTableCell-root": {
                                  backgroundColor: "rgb(32 80 130)",
                                  color: "#fff",
                                  div: {
                                    width: "max-content",
                                    textAlign: "left",
                                    padding: "10px",
                                  },
                                },
                              }}
                              key={item.id}
                            >
                              {communicationDetailsHeader &&
                                communicationDetailsHeader.length > 0 && (
                                  <TableCell
                                    style={{
                                      color: "#FFF",
                                      whiteSpace: "nowrap",
                                    }}
                                    align="left"
                                  >
                                    SL No.
                                  </TableCell>
                                )}
                              {communicationDetailsDynamiceHeader &&
                                communicationDetailsDynamiceHeader.map(
                                  (dynamiceHeader) => {
                                    return (
                                      <>
                                        {dynamiceHeader.IsShowWeb === true ? (
                                          <TableCell style={{ color: "#FFF" }}>
                                            <div>
                                              {dynamiceHeader &&
                                                dynamiceHeader.label}
                                            </div>
                                          </TableCell>
                                        ) : (
                                          ""
                                        )}
                                      </>
                                    );
                                  },
                                )}
                              {communicationDetailsHeader &&
                                communicationDetailsHeader.map((header) => {
                                  return (
                                    <>
                                      {header.isShowOnWeb === true && (
                                        <>
                                          {header.name ===
                                          "Total Amount (₹)" ? (
                                            <TableCell
                                              style={{ color: "#FFF" }}
                                              align="center"
                                            >
                                              <div style={{ display: "flex" }}>
                                                {header && header.displayName
                                                  ? header.displayName
                                                  : ""}
                                                <Tooltip
                                                  sx={{
                                                    color: "#fff",
                                                    display: "flex",
                                                  }}
                                                  title={
                                                    "Total Amt = Sum(Meeting Expense Amount (₹) + Daily Distance Fare (₹) + Total Expense(₹))"
                                                  }
                                                >
                                                  <IconButton>
                                                    <InfoIcon />
                                                  </IconButton>
                                                </Tooltip>
                                              </div>
                                            </TableCell>
                                          ) : (
                                            <TableCell
                                              style={{ color: "#FFF" }}
                                              align="center"
                                            >
                                              <div>
                                                {header && header.displayName
                                                  ? header.displayName
                                                  : ""}
                                              </div>
                                            </TableCell>
                                          )}
                                        </>
                                      )}
                                    </>
                                  );
                                })}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {item.map((element, i, itemArray) => {
                              console.log(itemArray);
                              return (
                                element.clientCommunicationDtoList &&
                                element.clientCommunicationDtoList.length > 0 &&
                                element.clientCommunicationDtoList.map(
                                  (elem, index, arr) => {
                                    // const n =
                                    //   elem.conclusion.includes("\n") &&
                                    //   elem.conclusion.replace(/\n/, "");
                                    // const copy = elem.conclusion.slice();
                                    // const t = elem.conclusion.slice(
                                    //   0,
                                    //   elem.conclusion.length - 3
                                    // );
                                    // const isBase64Encdoed = base64regex.test(
                                    //   t + "=="
                                    // );
                                    let count;
                                    if (index == 0) {
                                      count = 1;
                                    } else {
                                      count = 0;
                                    }

                                    slNo++;

                                    return (
                                      <TableRow
                                        key={elem.id}
                                        style={{
                                          placeContent: "center",
                                          backgroundColor: `${
                                            i % 2 == 0 ? "white" : "#F9F9F9"
                                          }`,
                                        }}
                                        hover
                                      >
                                        <TableCell>{slNo}</TableCell>
                                        {elem &&
                                          elem !== null &&
                                          elem !== undefined &&
                                          [elem].map(
                                            (element, index, array) => {
                                              return (
                                                <>
                                                  {communicationDetailsDynamiceHeader &&
                                                    communicationDetailsDynamiceHeader.map(
                                                      (header, ind) => {
                                                        const headerName =
                                                          header && header.uid;
                                                        const jsonDataMap =
                                                          element.jsonData !=
                                                          null
                                                            ? Object.fromEntries(
                                                                element.jsonData &&
                                                                  element.jsonData.map(
                                                                    (e) => [
                                                                      e.uid,
                                                                      e.value,
                                                                    ],
                                                                  ),
                                                              )
                                                            : null;

                                                        return (
                                                          <>
                                                            {header.IsShowWeb ===
                                                            true ? (
                                                              <>
                                                                {header.compName ===
                                                                  "image" ||
                                                                header.compName ===
                                                                  "File" ? (
                                                                  <TableCell align="center">
                                                                    {jsonDataMap &&
                                                                    jsonDataMap[
                                                                      headerName
                                                                    ] != null &&
                                                                    jsonDataMap[
                                                                      headerName
                                                                    ] !== "" ? (
                                                                      <Tooltip title="Click to view">
                                                                        <Avatar
                                                                          onClick={() =>
                                                                            OpenImageDirectTopage(
                                                                              jsonDataMap &&
                                                                                jsonDataMap[
                                                                                  headerName
                                                                                ] !=
                                                                                  null
                                                                                ? jsonDataMap[
                                                                                    headerName
                                                                                  ]
                                                                                : "",
                                                                            )
                                                                          }
                                                                          alt="Remy Sharp"
                                                                          src={
                                                                            jsonDataMap &&
                                                                            jsonDataMap[
                                                                              headerName
                                                                            ] !=
                                                                              null
                                                                              ? jsonDataMap[
                                                                                  headerName
                                                                                ]
                                                                              : ""
                                                                          }
                                                                        />
                                                                      </Tooltip>
                                                                    ) : (
                                                                      "NA"
                                                                    )}
                                                                  </TableCell>
                                                                ) : header.compName ===
                                                                  "Checkbox" ? (
                                                                  <TableCell
                                                                    align={
                                                                      /^\d+$/.test(
                                                                        (jsonDataMap &&
                                                                          jsonDataMap[
                                                                            headerName
                                                                          ]) ||
                                                                          "",
                                                                      )
                                                                        ? "right"
                                                                        : "left"
                                                                    }
                                                                  >
                                                                    {jsonDataMap &&
                                                                    jsonDataMap[
                                                                      headerName
                                                                    ] != null &&
                                                                    jsonDataMap[
                                                                      headerName
                                                                    ] !== "" &&
                                                                    jsonDataMap[
                                                                      headerName
                                                                    ] !==
                                                                      undefined
                                                                      ? jsonDataMap[
                                                                          headerName
                                                                        ] ==
                                                                        true
                                                                        ? "Yes"
                                                                        : "NO"
                                                                      : "NA"}
                                                                  </TableCell>
                                                                ) : header.compName ===
                                                                  "TextArea" ? (
                                                                  <TableCell
                                                                    align={
                                                                      /^\d+$/.test(
                                                                        (jsonDataMap &&
                                                                          jsonDataMap[
                                                                            headerName
                                                                          ]) ||
                                                                          "",
                                                                      )
                                                                        ? "right"
                                                                        : "left"
                                                                    }
                                                                  >
                                                                    {/* {jsonDataMap &&
                                                            jsonDataMap[
                                                              headerName
                                                            ] !==null &&
                                                            jsonDataMap[
                                                              headerName
                                                            ] !== "" &&
                                                           
                                                            base64regex.test(jsonDataMap[headerName] && jsonDataMap[headerName] !==null && jsonDataMap[headerName] !==""&&  jsonDataMap[headerName].replace(/\n/,""))
                                                              ? Base64.decode(
                                                                  jsonDataMap &&
                                                                    jsonDataMap[
                                                                      headerName
                                                                    ] != null &&
                                                                    jsonDataMap[
                                                                      headerName
                                                                    ] !== "" &&
                                                                    jsonDataMap[
                                                                      headerName
                                                                    ] !==
                                                                      undefined
                                                                    ? jsonDataMap[
                                                                        headerName
                                                                      ]
                                                                    : "NA"
                                                                )
                                                              : jsonDataMap &&
                                                                jsonDataMap[
                                                                  headerName
                                                                ] != null &&
                                                                jsonDataMap[
                                                                  headerName
                                                                ] !== "" &&
                                                                jsonDataMap[
                                                                  headerName
                                                                ] !== undefined
                                                              ? jsonDataMap[
                                                                  headerName
                                                                ]
                                                              : "NA"} */}
                                                                    {jsonDataMap &&
                                                                    jsonDataMap[
                                                                      headerName
                                                                    ] != null &&
                                                                    jsonDataMap[
                                                                      headerName
                                                                    ] !== "" &&
                                                                    jsonDataMap[
                                                                      headerName
                                                                    ] !==
                                                                      undefined
                                                                      ? jsonDataMap[
                                                                          headerName
                                                                        ]
                                                                      : "NA"}
                                                                  </TableCell>
                                                                ) : header.compName ===
                                                                  "Text" ? (
                                                                  <TableCell
                                                                    align={
                                                                      /^\d+$/.test(
                                                                        (jsonDataMap &&
                                                                          jsonDataMap[
                                                                            headerName
                                                                          ]) ||
                                                                          "",
                                                                      )
                                                                        ? "right"
                                                                        : "left"
                                                                    }
                                                                  >
                                                                    {/* {jsonDataMap &&
                                                            jsonDataMap[
                                                              headerName
                                                            ] !==null &&
                                                            jsonDataMap[
                                                              headerName
                                                            ] !== "" &&
                                                           
                                                            base64regex.test(jsonDataMap[headerName] && jsonDataMap[headerName] !==null && jsonDataMap[headerName] !==""&&  jsonDataMap[headerName].replace(/\n/,""))
                                                              ? Base64.decode(
                                                                  jsonDataMap &&
                                                                    jsonDataMap[
                                                                      headerName
                                                                    ] != null &&
                                                                    jsonDataMap[
                                                                      headerName
                                                                    ] !== "" &&
                                                                    jsonDataMap[
                                                                      headerName
                                                                    ] !==
                                                                      undefined
                                                                    ? jsonDataMap[
                                                                        headerName
                                                                      ]
                                                                    : "NA"
                                                                )
                                                              : jsonDataMap &&
                                                                jsonDataMap[
                                                                  headerName
                                                                ] != null &&
                                                                jsonDataMap[
                                                                  headerName
                                                                ] !== "" &&
                                                                jsonDataMap[
                                                                  headerName
                                                                ] !== undefined
                                                              ? jsonDataMap[
                                                                  headerName
                                                                ]
                                                              : "NA"} */}
                                                                    {jsonDataMap &&
                                                                    jsonDataMap[
                                                                      headerName
                                                                    ] != null &&
                                                                    jsonDataMap[
                                                                      headerName
                                                                    ] !== "" &&
                                                                    jsonDataMap[
                                                                      headerName
                                                                    ] !==
                                                                      undefined
                                                                      ? jsonDataMap[
                                                                          headerName
                                                                        ]
                                                                      : "NA"}
                                                                  </TableCell>
                                                                ) : (
                                                                  <TableCell
                                                                    align={
                                                                      /^\d+$/.test(
                                                                        (jsonDataMap &&
                                                                          jsonDataMap[
                                                                            headerName
                                                                          ]) ||
                                                                          "",
                                                                      )
                                                                        ? "right"
                                                                        : "left"
                                                                    }
                                                                  >
                                                                    {jsonDataMap &&
                                                                    jsonDataMap[
                                                                      headerName
                                                                    ] != null &&
                                                                    jsonDataMap[
                                                                      headerName
                                                                    ] !== "" &&
                                                                    jsonDataMap[
                                                                      headerName
                                                                    ] !==
                                                                      undefined
                                                                      ? jsonDataMap[
                                                                          headerName
                                                                        ]
                                                                      : "NA"}
                                                                  </TableCell>
                                                                )}
                                                              </>
                                                            ) : (
                                                              ""
                                                            )}
                                                          </>
                                                        );
                                                      },
                                                    )}
                                                </>
                                              );
                                            },
                                          )}
                                        {/* <TableCell></TableCell>
                                  <TableCell></TableCell>
                                  <TableCell></TableCell> */}
                                        {communicationDetailsHeader &&
                                        communicationDetailsHeader[0]
                                          .isShowOnWeb === true ? (
                                          <TableCell
                                            style={{
                                              minWidth: "140px",
                                            }}
                                          >
                                            <Box
                                              sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "10px",
                                              }}
                                            >
                                              <span style={{ float: "left" }}>
                                                {elem.isNewClient === true ? (
                                                  <img
                                                    src={gif}
                                                    width="35px"
                                                    alt=""
                                                  />
                                                ) : (
                                                  ""
                                                )}
                                              </span>
                                              <span>
                                                {/* {elem.createDate} */}
                                                {moment(
                                                  elem.createdDateTime,
                                                ).format("DD/MM/YYYY hh:mm A")}
                                              </span>
                                            </Box>
                                          </TableCell>
                                        ) : (
                                          ""
                                        )}
                                        {/* {configurationName !== undefined &&
                                          configurationName ===
                                            "IS_MEETING_DURATION" && (
                                            <> */}
                                        {communicationDetailsHeader &&
                                        communicationDetailsHeader[1]
                                          ?.isShowOnWeb === true ? (
                                          <TableCell
                                            sx={{ minWidth: "180px" }}
                                            align="left"
                                          >
                                            {elem && elem.meetingOnDateTime
                                              ? moment(
                                                  elem.meetingOnDateTime,
                                                ).format("hh:mm A")
                                              : "NA"}
                                          </TableCell>
                                        ) : (
                                          ""
                                        )}
                                        {communicationDetailsHeader &&
                                        communicationDetailsHeader[2]
                                          ?.isShowOnWeb === true ? (
                                          <TableCell
                                            sx={{ minWidth: "180px" }}
                                            align="left"
                                          >
                                            {elem && elem.meetingOffDateTime
                                              ? moment(
                                                  elem.meetingOffDateTime,
                                                ).format("hh:mm A")
                                              : "NA"}
                                          </TableCell>
                                        ) : (
                                          ""
                                        )}
                                        {communicationDetailsHeader &&
                                        communicationDetailsHeader[3]
                                          ?.isShowOnWeb === true ? (
                                          <TableCell
                                            sx={{ minWidth: "180px" }}
                                            align="left"
                                          >
                                            {elem && elem.startAddress
                                              ? elem.startAddress
                                              : "NA"}
                                          </TableCell>
                                        ) : (
                                          ""
                                        )}
                                        {communicationDetailsHeader &&
                                        communicationDetailsHeader[4]
                                          ?.isShowOnWeb === true ? (
                                          <TableCell
                                            sx={{ minWidth: "180px" }}
                                            align="left"
                                          >
                                            {elem && elem.address
                                              ? elem.address
                                              : "NA"}
                                          </TableCell>
                                        ) : (
                                          ""
                                        )}
                                        {communicationDetailsHeader &&
                                        communicationDetailsHeader[5]
                                          ?.isShowOnWeb === true ? (
                                          <TableCell
                                            sx={{ minWidth: "180px" }}
                                            align="right"
                                          >
                                            {elem && elem.meetingDuration
                                              ? elem.meetingDuration
                                              : "NA"}
                                          </TableCell>
                                        ) : (
                                          ""
                                        )}
                                        {/* </>
                                          )} */}
                                        {communicationDetailsHeader &&
                                        communicationDetailsHeader[6]
                                          ?.isShowOnWeb === true ? (
                                          <TableCell
                                            align="left"
                                            style={{
                                              minWidth: "160px",
                                            }}
                                          >
                                            <p>
                                              Start:{" "}
                                              {element && element.createdDate
                                                ? moment(
                                                    element.createdDate,
                                                  ).format("hh:mm A")
                                                : "NA"}
                                            </p>
                                            <p>
                                              End:{" "}
                                              {element && element.date
                                                ? moment(element.date).format(
                                                    "hh:mm A",
                                                  )
                                                : "NA"}
                                            </p>
                                            {/* {`${(element.startTime)}  ${(element.endTime)}`} */}
                                          </TableCell>
                                        ) : (
                                          ""
                                        )}
                                        {communicationDetailsHeader &&
                                        communicationDetailsHeader[7]
                                          ?.isShowOnWeb === true ? (
                                          <TableCell
                                            align="left"
                                            style={{
                                              minWidth: "160px",
                                            }}
                                          >
                                            {elem.clientName}{" "}
                                            {elem?.locationVisitId && (
                                              <Tooltip
                                                sx={{
                                                  color: "#103a71",
                                                  display: "flex",
                                                }}
                                                title={
                                                  "Click to view default meeting details"
                                                }
                                              >
                                                <IconButton
                                                  onClick={() =>
                                                    handleViewDefaultMeeting(
                                                      elem,
                                                    )
                                                  }
                                                >
                                                  <InfoIcon />
                                                </IconButton>
                                              </Tooltip>
                                            )}
                                          </TableCell>
                                        ) : (
                                          ""
                                        )}
                                        {communicationDetailsHeader &&
                                        communicationDetailsHeader[8]
                                          ?.isShowOnWeb === true ? (
                                          <TableCell align="left">
                                            {elem.contactPerson}
                                          </TableCell>
                                        ) : (
                                          ""
                                        )}
                                        {communicationDetailsHeader &&
                                        communicationDetailsHeader[9]
                                          ?.isShowOnWeb === true ? (
                                          <TableCell
                                            align="left"
                                            style={{
                                              minWidth: "120px",
                                            }}
                                          >
                                            {`${elem.userName} ${
                                              itemArray[0].empCode
                                                ? `(${itemArray[0].empCode})`
                                                : "NA"
                                            }`}
                                          </TableCell>
                                        ) : (
                                          ""
                                        )}
                                        {communicationDetailsHeader &&
                                        communicationDetailsHeader[10]
                                          ?.isShowOnWeb === true ? (
                                          <TableCell
                                            align="left"
                                            style={{
                                              minWidth: "160px",
                                            }}
                                          >
                                            {elem &&
                                            elem.clientCurrentStatus &&
                                            elem.clientCurrentStatus !== null
                                              ? elem.clientCurrentStatus
                                                  .statusName
                                              : "NA"}
                                          </TableCell>
                                        ) : (
                                          ""
                                        )}
                                        {/* {JSON.parse(
                                          localStorage.getItem("data")
                                        ).hrmsCompanyId == 14 ? (
                                          <> */}
                                        {communicationDetailsHeader &&
                                        communicationDetailsHeader[11]
                                          ?.isShowOnWeb === true ? (
                                          <TableCell>
                                            {elem &&
                                            elem.clientType &&
                                            elem.clientType !== null
                                              ? elem.clientType
                                              : "NA"}
                                          </TableCell>
                                        ) : (
                                          ""
                                        )}
                                        {/* </>
                                        ) : (
                                          ""
                                        )} */}
                                        {communicationDetailsHeader &&
                                        communicationDetailsHeader[12]
                                          ?.isShowOnWeb === true ? (
                                          <TableCell align="right">
                                            {elem.contactPersonNo &&
                                              elem.contactPersonNo}
                                          </TableCell>
                                        ) : (
                                          ""
                                        )}
                                        {communicationDetailsHeader &&
                                        communicationDetailsHeader[13]
                                          ?.isShowOnWeb === true ? (
                                          <TableCell
                                            align="left"
                                            style={{
                                              minWidth: "80px",
                                            }}
                                          >
                                            <div
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                              }}
                                            >
                                              <p>
                                                {elem && elem.mode && elem.mode}
                                              </p>
                                              <p>
                                                {elem &&
                                                elem.visitingCardUrl &&
                                                elem &&
                                                elem.visitingCardUrl !== null &&
                                                elem &&
                                                elem.visitingCardUrl !== "" ? (
                                                  <IconButton
                                                    onClick={() =>
                                                      viewImageRidarect(
                                                        elem &&
                                                          elem.visitingCardUrl,
                                                      )
                                                    }
                                                  >
                                                    <InfoIcon />
                                                  </IconButton>
                                                ) : (
                                                  ""
                                                )}
                                              </p>
                                            </div>
                                          </TableCell>
                                        ) : (
                                          ""
                                        )}
                                        {communicationDetailsHeader &&
                                        communicationDetailsHeader[14]
                                          ?.isShowOnWeb === true ? (
                                          <TableCell
                                            align="left"
                                            style={{
                                              minWidth: "120px",
                                            }}
                                          >
                                            {elem.reason}
                                          </TableCell>
                                        ) : (
                                          ""
                                        )}
                                        {communicationDetailsHeader &&
                                        communicationDetailsHeader[15]
                                          ?.isShowOnWeb === true ? (
                                          <TableCell
                                            align="left"
                                            style={{
                                              minWidth: "120px",
                                            }}
                                          >
                                            {elem.conclusion !== ""
                                              ? elem.conclusion
                                              : "NA"}
                                            {/* {elem &&
                                            elem.conclusion &&
                                            elem.conclusion.includes("\n") &&
                                            base64regex.test(
                                              elem.conclusion.replace(/\n/, "")
                                            )
                                              ? Base64.decode(elem.conclusion)
                                              : elem.conclusion
                                              ? elem.conclusion
                                              : "NA"} */}
                                          </TableCell>
                                        ) : (
                                          ""
                                        )}
                                        {communicationDetailsHeader &&
                                        communicationDetailsHeader[16]
                                          ?.isShowOnWeb === true ? (
                                          <TableCell
                                            align="left"
                                            style={{
                                              minWidth: "120px",
                                            }}
                                          >
                                            {elem.remarks ? elem.remarks : "NA"}
                                            {/* {elem &&
                                            elem.remarks &&
                                            elem.remarks.includes("\n") &&
                                            base64regex.test(
                                              elem.remarks.replace(/\n/, "")
                                            )
                                              ? Base64.decode(elem.remarks)
                                              : elem.remarks
                                              ? elem.remarks
                                              : "NA"} */}
                                          </TableCell>
                                        ) : (
                                          ""
                                        )}
                                        {communicationDetailsHeader &&
                                        communicationDetailsHeader[17]
                                          ?.isShowOnWeb === true ? (
                                          <TableCell
                                            align="left"
                                            style={{
                                              minWidth: "120px",
                                            }}
                                          >
                                            {elem.visitPlace}
                                          </TableCell>
                                        ) : (
                                          ""
                                        )}
                                        {/* {JSON.parse(
                                          localStorage.getItem("showHeader")
                                        ) == true ? (
                                          <> */}
                                        {communicationDetailsHeader &&
                                        communicationDetailsHeader[18]
                                          ?.isShowOnWeb === true ? (
                                          <TableCell align="right">
                                            {" "}
                                            {elem.meetingDistance
                                              ? `${elem.meetingDistance}`
                                              : "0.00"}
                                          </TableCell>
                                        ) : (
                                          ""
                                        )}
                                        {communicationDetailsHeader &&
                                        communicationDetailsHeader[19]
                                          ?.isShowOnWeb === true ? (
                                          <TableCell align="right">
                                            {" "}
                                            {elem.distanceFare
                                              ? `${elem.distanceFare.toFixed(
                                                  2,
                                                )}`
                                              : "0.00"}
                                          </TableCell>
                                        ) : (
                                          ""
                                        )}
                                        {/* </>
                                        ) : (
                                          ""
                                        )} */}
                                        {communicationDetailsHeader &&
                                        communicationDetailsHeader[20]
                                          ?.isShowOnWeb === true ? (
                                          <TableCell
                                            align="right"
                                            style={{
                                              minWidth: "160px",
                                            }}
                                          >
                                            <span
                                              onClick={() =>
                                                openmodalhalndlerSingleID(elem)
                                              }
                                            >
                                              {elem &&
                                              elem.clientTotalExpenseAmount &&
                                              elem.clientTotalExpenseAmount !==
                                                null ? (
                                                <IconButton>
                                                  <InfoIcon />
                                                </IconButton>
                                              ) : (
                                                ""
                                              )}
                                            </span>
                                            {elem.clientTotalExpenseAmount
                                              ? `${`${elem.clientTotalExpenseAmount.toFixed(
                                                  2,
                                                )}`}`
                                              : "0.00"}
                                          </TableCell>
                                        ) : (
                                          ""
                                        )}
                                        {count == 1 && (
                                          <>
                                            {communicationDetailsHeader &&
                                            communicationDetailsHeader[21]
                                              ?.isShowOnWeb === true ? (
                                              <TableCell
                                                sx={{
                                                  borderLeft:
                                                    "1px solid rgba(224, 224, 224, 1)",
                                                }}
                                                align="right"
                                                rowSpan={arr.length}
                                              >
                                                <Button
                                                  // onClick={() =>
                                                  //   handleView(
                                                  //     elem.usersId,
                                                  //     elem.createdDateTime
                                                  //   )
                                                  // }
                                                  style={{ color: "#23b0a9" }}
                                                >
                                                  {/* {element.totalDistance?element.totalDistance.toFixed(2):"NA"} */}
                                                  {element.totalDistance
                                                    ? `${element.totalDistance.toFixed(
                                                        2,
                                                      )}`
                                                    : "0.00"}

                                                  {/* <img src={eyeIcon}></img> */}
                                                  {/* View */}
                                                </Button>
                                              </TableCell>
                                            ) : (
                                              ""
                                            )}
                                          </>
                                        )}{" "}
                                        {count == 1 && (
                                          <>
                                            {communicationDetailsHeader &&
                                            communicationDetailsHeader[22]
                                              ?.isShowOnWeb === true ? (
                                              <TableCell
                                                sx={{
                                                  borderLeft:
                                                    "1px solid rgba(224, 224, 224, 1)",
                                                  minWidth: "160px",
                                                }}
                                                align="right"
                                                rowSpan={arr.length}
                                              >
                                                {element.totalAmountForOd
                                                  ? `${element.totalAmountForOd.toFixed(
                                                      2,
                                                    )}`
                                                  : "0.00"}
                                              </TableCell>
                                            ) : (
                                              ""
                                            )}
                                          </>
                                        )}
                                        {count == 1 && (
                                          <>
                                            {communicationDetailsHeader &&
                                            communicationDetailsHeader[23]
                                              ?.isShowOnWeb === true ? (
                                              <TableCell
                                                sx={{
                                                  borderLeft:
                                                    "1px solid rgba(224, 224, 224, 1)",
                                                  minWidth: "160px",
                                                }}
                                                align="right"
                                                rowSpan={arr.length}
                                              >
                                                <span>
                                                  {element.odExpenseAmount
                                                    ? `${element.odExpenseAmount}`
                                                    : "0.00"}
                                                </span>
                                                {/* <span
                                              onClick={() =>
                                                openmodalhalndler(
                                                  elem.userExpenseDtoList
                                                )
                                              }
                                            >
                                              <IconButton>
                                                <InfoIcon />
                                              </IconButton>
                                            </span> */}
                                              </TableCell>
                                            ) : (
                                              ""
                                            )}
                                          </>
                                        )}
                                        {count == 1 && (
                                          <>
                                            {communicationDetailsHeader &&
                                            communicationDetailsHeader[24]
                                              ?.isShowOnWeb === true ? (
                                              <TableCell
                                                sx={{
                                                  borderLeft:
                                                    "1px solid rgba(224, 224, 224, 1)",
                                                  minWidth: "170px",
                                                }}
                                                //align="center"
                                                rowSpan={arr.length}
                                              >
                                                <Button
                                                  style={{
                                                    color: "#23b0a9",
                                                    cursor: "pointer",
                                                  }}
                                                ></Button>
                                                <p
                                                  style={{
                                                    color: "green",
                                                    cursor: "pointer",
                                                    display: "flex",
                                                    justifyContent:
                                                      "space-between",
                                                  }}
                                                  onClick={() =>
                                                    openmodalhalndler(
                                                      "APPROVED",
                                                      element,
                                                    )
                                                  }
                                                >
                                                  <span>Approved:</span>
                                                  <span>
                                                    {element.totalApprovedExpenseAndFareAmount
                                                      ? `${element.totalApprovedExpenseAndFareAmount.toFixed(
                                                          2,
                                                        )}`
                                                      : "0.00"}
                                                  </span>
                                                </p>
                                                <p
                                                  style={{
                                                    color: "red",
                                                    cursor: "pointer",
                                                    display: "flex",
                                                    justifyContent:
                                                      "space-between",
                                                  }}
                                                  onClick={() =>
                                                    openmodalhalndler(
                                                      "REJECTED",
                                                      element,
                                                    )
                                                  }
                                                >
                                                  <span>Rejected:</span>
                                                  <span>
                                                    {element.totalRejectedExpenseAndFareAmount
                                                      ? `${element.totalRejectedExpenseAndFareAmount.toFixed(
                                                          2,
                                                        )}`
                                                      : "0.00"}
                                                  </span>
                                                </p>
                                                <p
                                                  style={{
                                                    color: "#a9a92f",
                                                    cursor: "pointer",
                                                    display: "flex",
                                                    justifyContent:
                                                      "space-between",
                                                  }}
                                                  onClick={() =>
                                                    openmodalhalndler(
                                                      "PENDING",
                                                      element,
                                                    )
                                                  }
                                                >
                                                  <span>Pending:</span>
                                                  <span>
                                                    {element.totalPendingExpenseAndFareAmount
                                                      ? `${element.totalPendingExpenseAndFareAmount.toFixed(
                                                          2,
                                                        )}`
                                                      : "0.00"}
                                                  </span>
                                                </p>
                                                <p
                                                  style={{
                                                    color: "#a9a92f",
                                                    cursor: "pointer",
                                                    display: "flex",
                                                    justifyContent:
                                                      "space-between",
                                                  }}
                                                  onClick={() =>
                                                    openmodalhalndler(
                                                      "Total",
                                                      element,
                                                    )
                                                  }
                                                >
                                                  <span>Total: </span>
                                                  <span>
                                                    {element.totalExpenseAndFareAmount
                                                      ? `${element.totalExpenseAndFareAmount?.toFixed(2)}`
                                                      : "0.00"}
                                                  </span>
                                                </p>
                                              </TableCell>
                                            ) : (
                                              ""
                                            )}
                                          </>
                                        )}
                                        {localData?.isOdMeterReadingRequiredOnOd &&
                                          count === 1 && (
                                            <>
                                              {communicationDetailsHeader &&
                                              communicationDetailsHeader[25]
                                                ?.isShowOnWeb === true ? (
                                                <TableCell
                                                  sx={{
                                                    paddingLeft: 1,
                                                    borderLeft:
                                                      "1px solid rgba(224, 224, 224, 1)",
                                                    minWidth: "170px",
                                                  }}
                                                  rowSpan={arr.length}
                                                  //align="center"
                                                >
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      flexDirection: "row",
                                                      gap: 1,
                                                      alignItems: "center",
                                                      justifyContent:
                                                        "space-between",
                                                    }}
                                                  >
                                                    <p
                                                      style={{
                                                        color: "green",
                                                      }}
                                                    >
                                                      Start:
                                                      {element.odoMeterStartReading
                                                        ? `${element.odoMeterStartReading.toFixed(
                                                            2,
                                                          )}`
                                                        : "NA"}
                                                    </p>
                                                    <IconButton
                                                      onClick={() =>
                                                        viewImageRidarect(
                                                          element?.odoMeterStartImageUrl,
                                                        )
                                                      }
                                                    >
                                                      <InfoIcon
                                                        sx={{
                                                          fontSize: "20px",
                                                        }}
                                                      />
                                                    </IconButton>
                                                  </div>

                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      flexDirection: "row",
                                                      gap: 1,
                                                      alignItems: "center",
                                                      justifyContent:
                                                        "space-between",
                                                    }}
                                                  >
                                                    <p
                                                      style={{
                                                        color: "green",
                                                      }}
                                                    >
                                                      End:
                                                      {element.odoMeterEndReading
                                                        ? `${element.odoMeterEndReading.toFixed(
                                                            2,
                                                          )}`
                                                        : "NA"}
                                                    </p>
                                                    <IconButton
                                                      onClick={() =>
                                                        viewImageRidarect(
                                                          element?.odoMeterEndImageUrl,
                                                        )
                                                      }
                                                    >
                                                      <InfoIcon
                                                        sx={{
                                                          fontSize: "20px",
                                                        }}
                                                      />
                                                    </IconButton>
                                                  </div>
                                                </TableCell>
                                              ) : (
                                                ""
                                              )}
                                            </>
                                          )}
                                        {localData?.isOdMeterReadingRequiredOnOd &&
                                          count === 1 && (
                                            <>
                                              {communicationDetailsHeader &&
                                              communicationDetailsHeader[25]
                                                ?.isShowOnWeb === true ? (
                                                <TableCell
                                                  sx={{
                                                    paddingLeft: 1,
                                                    borderLeft:
                                                      "1px solid rgba(224, 224, 224, 1)",
                                                    minWidth: "170px",
                                                  }}
                                                  rowSpan={arr.length}
                                                  //align="center"
                                                >
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      flexDirection: "row",
                                                      gap: 1,
                                                      alignItems: "center",
                                                      justifyContent:
                                                        "space-between",
                                                    }}
                                                  >
                                                    <p
                                                      style={{
                                                        marginTop: "10px",
                                                        // cursor: "pointer",
                                                      }}
                                                      // onClick={() => openmodalhalndler("APPROVED", element)}
                                                    >
                                                      Distance:
                                                      {element.odoMeterDistanceDifference
                                                        ? `${element.odoMeterDistanceDifference.toFixed(
                                                            2,
                                                          )}`
                                                        : "NA"}
                                                    </p>
                                                  </div>
                                                </TableCell>
                                              ) : (
                                                ""
                                              )}
                                            </>
                                          )}
                                        {count == 1 && (
                                          <>
                                            {communicationDetailsHeader &&
                                            communicationDetailsHeader[27]
                                              ?.isShowOnWeb === true ? (
                                              <TableCell
                                                sx={{
                                                  borderLeft:
                                                    "1px solid rgba(224, 224, 224, 1)",
                                                  borderRight:
                                                    "1px solid rgba(224, 224, 224, 1)",
                                                }}
                                                align="center"
                                                rowSpan={arr.length}
                                              >
                                                <Button
                                                  onClick={() =>
                                                    handleView(
                                                      elem.usersId,
                                                      elem.createdDateTime,
                                                      element?.id,
                                                    )
                                                  }
                                                  style={{ color: "#23b0a9" }}
                                                >
                                                  <img src={eyeIcon}></img>
                                                  {/* View */}
                                                </Button>
                                              </TableCell>
                                            ) : (
                                              ""
                                            )}
                                          </>
                                        )}
                                        {/* meeting skip details icon */}
                                        {count === 1 && (
                                          <>
                                            {communicationDetailsHeader &&
                                            communicationDetailsHeader[28]
                                              ?.isShowOnWeb === true ? (
                                              <TableCell
                                                sx={{
                                                  borderLeft:
                                                    "1px solid rgba(224, 224, 224, 1)",
                                                  borderRight:
                                                    "1px solid rgba(224, 224, 224, 1)",
                                                }}
                                                align="center"
                                                rowSpan={arr && arr.length}
                                              >
                                                <CustomUserModal
                                                  title={
                                                    communicationDetailsHeader[28]
                                                      .displayName
                                                  }
                                                  item={element}
                                                />
                                              </TableCell>
                                            ) : (
                                              ""
                                            )}
                                          </>
                                        )}
                                      </TableRow>
                                    );
                                  },
                                )
                              );
                            })}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </AccordionDetails>
                  </Accordion>
                }
              </Container>
              <ImageView
                title={"Image"}
                imageUrl={ImgUrl}
                open={OpenViewImageModal}
                setOpen={setOpenViewImageModal}
              />

              <div style={{ display: "none" }}>
                <EmpWisTable
                  item={tableId}
                  configurationName={configurationName}
                  communicationDetailsHeader={communicationDetailsHeader}
                  communicationDetailsDynamiceHeader={
                    communicationDetailsDynamiceHeader
                  }
                  totalDistance={totalDistance}
                />
              </div>
            </React.Fragment>
          );
        })}
    </div>
  );
};

export default React.memo(IndividualReport);
